/**
 * The enumeration defines possible input types for a PowerShell script.
 *
 * @see https://github.com/Microsoft/MIMWAL/blob/master/src/WorkflowActivityLibrary/Enumerations/PowerShellInputType.cs
 */
export enum PowerShellInputType {
  /**
   * The script does not take any input
   */
  None,

  /**
   * The script uses named parameters as input
   */
  Parameters,

  /**
   * The script uses arguments as input
   */
  Arguments,
}
